
export const RESOLUTIONS = [
    2048.256,
    1024.128,
    512.064,
    256.032,
    128.016,
    64.008,
    32.004,
    16.002,
    8.001,
    4.0005,
    2.00025,
    1.000125,
    0.5000625,
    0.25003125,
    0.125015625,
    0.0625078125
];

const CUZK_WMTS_TILE_GRID = {
    extent: [
        -925000.000000000000, -1444353.535999999800,
        -400646.464000000040, -920000.000000000000
    ],
    projection: 'epsg:5514',
    resolutions: RESOLUTIONS,
    matrixIds: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15']
};

const MAP_PROJECT = {
    projection: 'epsg:5514',
    resolutions: RESOLUTIONS,
    extent: [
        -925000.000000000000, -1444353.535999999800,
        -400646.464000000040, -920000.000000000000
    ],
    minZoom: 0,
    maxZoom: 15,

    layers: [{
        id: 'zm',
        type: 'WMTS',
        source: {
            params: {
                url: 'https://geoportal.cuzk.cz/WMTS_ZM/WMTService.aspx',
                matrixSet: 'jtsk:epsg:5514',
                layer: 'zm',
                projection: 'epsg:5514',
                format: 'image/png',
                style: 'default'
            },
            tileGrid: CUZK_WMTS_TILE_GRID
        }
    }, {
        id: 'orto',
        type: 'WMTS',
        source: {
            params: {
                url: 'https://geoportal.cuzk.cz/WMTS_ORTOFOTO/WMTService.aspx',
                matrixSet: 'jtsk:epsg:5514',
                layer: 'orto',
                projection: 'epsg:5514',
                format: 'image/png',
                style: 'default'
            },
            tileGrid: CUZK_WMTS_TILE_GRID
        }
    }, {
        id: 'cuzk_dmr5g',
        type: 'ImageWMS',
        source: {
            url: 'https://ags.cuzk.cz/arcgis2/services/dmr5g/ImageServer/WMSServer',
            params: {
                'LAYERS': 'dmr5g:GrayscaleHillshade',
                'FORMAT': 'image/jpeg'
            },
            ratio: 1.0
        }
    }, {
        id: 'pluziny',
        type: 'ImageWMS',
        source: {
            url: 'https://naki-pluziny.hfbiz.cz/mapserver?map=/data/default.map',
            params: {
                'LAYERS': 'pluziny,pluziny_text',
                'FORMAT': 'image/png'
            },
            ratio: 1.0
        }
    }, {
        id: 'pluziny_lidar',
        type: 'ImageWMS',
        source: {
            url: 'https://naki-pluziny.hfbiz.cz/mapserver?map=/data/default.map',
            params: {
                'LAYERS': 'pluziny_lidar',
                'FORMAT': 'image/png'
            },
            ratio: 1.0
        }
    }, {
        id: 'cuzk_km',
        type: 'ImageWMS',
        maxResolution: 2.00025,
        source: {
            url: 'https://services.cuzk.cz/wms/local-KM-wms.asp',
            params: {'LAYERS': 'KN'}
        }
    }, {
        id: 'cuzk_km_i',
        type: 'ImageWMS',
        maxResolution: 2.00025,
        source: {
            url: 'https://services.cuzk.cz/wms/local-KM-wms.asp',
            params: {'LAYERS': 'KN_I'}
        }
    }, {
        id: 'useky',
        type: 'Vector',
        style: {
            default: {
                type: 'line',
                color: '#ff0000',
                width: 3
            },
            highlight: {
                type: 'line',
                color: '#ffff00',
                width: 5
            }
        }
    }],

    virtualLayers: [{
        id: 'base_empty',
        base: true,
        layers: [],
        title: 'Prázdný podklad'
    }, {
        id: 'base_zm',
        base: true,
        layers: ['zm'],
        title: 'Základní mapa [ČÚZK]'
    }, {
        id: 'base_orto',
        base: true,
        layers: ['orto'],
        title: 'Letecká mapa [ČÚZK]'
    }, {
        id: 'base_cuzk_dmr5g',
        base: true,
        layers: ['cuzk_dmr5g'],
        title: 'Digitální model reliéfu 5.generace [ČÚZK]'
    }, {
        id: 'over_pluziny',
        layers: ['pluziny'],
        title: 'Plužiny - současně dochované'
    }, {
        id: 'over_pluziny_lidar',
        layers: ['pluziny_lidar'],
        title: 'Plužiny - viditelné na LIDARovém snímku'
    }, {
        id: 'over_cuzk_km',
        layers: ['cuzk_km'],
        title: 'Katastrální mapa [ČÚZK]',
        maxResolution: 1.000125
    }, {
        id: 'over_cuzk_km_i',
        layers: ['cuzk_km_i'],
        title: 'Katastrální mapa inverzní [ČÚZK]',
        maxResolution: 1.000125
    }, {
        id: 'over_useky',
        layers: ['useky'],
        title: 'Úseky mezí - návrh pro kalkulaci'
    }],

    virtualLayerGroups: [{
        id: 'base',
        base: true,
        title: 'Podkladové vrstvy',
        layers: [
            'base_empty',
            'base_zm',
            'base_orto',
            'base_cuzk_dmr5g',
        ]
    }, {
        id: 'over',
        title: 'Volitelné vrstvy',
        layers: [
            'over_pluziny',
            'over_pluziny_lidar',
            'over_cuzk_km',
            'over_cuzk_km_i',
            'over_useky'
        ]
    }],

    defaultVisibleLayers: ['base_zm', 'over_useky', 'over_pluziny']
};

export default MAP_PROJECT;
